module.exports = __webpack_public_path__ + "static/media/link-symbol-copy.3afed2e3.svg";